import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Modal, { ModalBody, ModalFooter, ModalHeader, ModalTitle } from '../../bootstrap/Modal';
// import data from './DataInstansi';
import FormGroup from '../../bootstrap/forms/FormGroup';
import Input from '../../bootstrap/forms/Input';
import Button from '../../bootstrap/Button';
import showNotification from '../../extras/showNotification';
import Icon from '../../icon/Icon';
import GlobalServices from '../Services/GlobalServices';

const ModalTambah = ({ id, isOpen, setIsOpen, statusRefresh, uuidInstansi }) => {
	const token = sessionStorage.getItem('access_token');
	const formData = {
		title: 'Tambah Data Tempat Tugas',
		id: null,
		nama: '',
	};

	const [list, setList] = useState([]);

	useEffect(() => {
		GlobalServices.getAll('instansi', token).then((hasil) => {
			// console.log(hasil);
			setList(hasil.results.data);
		});
	}, []); // eslint-disable-line react-hooks/exhaustive-deps

	const [selectedInstansi, setSelectedInstansi] = useState(null);
	const handleSelectChangeInstansi = (event) => {
		setSelectedInstansi(event.target.value);
	};

	const [instansi, setInstansi] = useState(formData);
	const handleInputChange = (event) => {
		const { name, value } = event.target;
		setInstansi({ ...instansi, [name]: value });
	};

	const handleSubmit = () => {
		const data = {
			uuid_instansi: uuidInstansi,
			nama: instansi.nama,
		};

		if (instansi.nama !== '' && uuidInstansi) {
			GlobalServices.create(data, `tempat-tugas`, token)
				.then((response) => {
					if (response.data.code === 201) {
						setIsOpen(false);
						setSelectedInstansi(null);
						showNotification(
							<span className='d-flex align-items-center'>
								<Icon icon='Info' size='lg' className='me-1' />
								<span>Berhasil Tambah Data</span>
							</span>,
							'Berhasil Tambah Data Tempat Tugas',
						);
						statusRefresh();
						setInstansi(formData)
					} else {
						// setIsOpen(false);
						showNotification(
							<span className='d-flex align-items-center'>
								<Icon icon='Warning' size='lg' className='me-1' />
								<span>Gagal Tambah Data</span>
							</span>,
							'Gagal Tambah Data Tempat Tugas',
						);
					}
				})
				.catch((e) => {
					console.log(e);
				});
		} else {
			// setIsOpen(false);
			showNotification(
				<span className='d-flex align-items-center'>
					<Icon icon='Warning' size='lg' className='me-1' />
					<span>Gagal Tambah Data</span>
				</span>,
				'Data Tidak Lengkap!',
			);
		}
	};

	if (id || id === 0) {
		return (
			<Modal isOpen={isOpen} setIsOpen={setIsOpen} isStaticBackdrop size='md' titleId={id}>
				<form onSubmit={(e) => e.preventDefault()}>
				<ModalHeader setIsOpen={setIsOpen} className='p-4'>
					<ModalTitle id={id}>{instansi.title}</ModalTitle>
				</ModalHeader>
				<ModalBody className='px-4'>
					<div className='row g-4'>
						<FormGroup id='nama' label='Tempat Tugas' className='col-md-12'>
							<Input
								type='text'
								name='nama'
								value={instansi.nama}
								onChange={handleInputChange}
								required
							/>
						</FormGroup>
					</div>
				</ModalBody>
				<ModalFooter className='px-4 pb-4'>
					<Button
						color='success'
						// isOutline
						// className='border-0'
						onClick={() => {
							setIsOpen(false);
							setInstansi(formData);
							setSelectedInstansi(null);
						}}>
						Batal
					</Button>
					{/* <Button color='info' onClick={formik.handleSubmit}> */}
					<Button color='info' type='submit' onClick={handleSubmit}>
						Simpan
					</Button>
				</ModalFooter>
				</form>
			</Modal>
		);
	}
	return null;
};
ModalTambah.propTypes = {
	id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
	isOpen: PropTypes.bool.isRequired,
	setIsOpen: PropTypes.func.isRequired,
	uuidInstansi: PropTypes.func.isRequired,
	statusRefresh: PropTypes.func.isRequired,
};

export default ModalTambah;
